export const EMAIL_ID           = 'in2arkadipb13@gmail.com';
export const WEBSITE_LINK       = 'https://darkmatter18.cf';

export const RESUME_LINK        = 'https://drive.google.com/file/d/1x72cMtKz7RxO_ZG32P-_dh2QPq7zk8TL/view?usp=sharing';
export const GITHUB_LINK        = 'https://github.com/darkmatter18';
export const LINKEDIN_LINK      = 'https://www.linkedin.com/in/arkadip';
export const FACEBOOK_LINK      = 'https://facebook.com/arkadipb';
export const INSTAGRAM_LINK     = 'https://www.instagram.com/__dark_matter';
export const TWITTER_LINK       = 'https://twitter.com/in2arkadipb13';

export const G_RECAPTA_TOKEN    = '6LcGQncUAAAAAKYAaNg7ciOYFBEGMuaTQWbA8cEl';